import React, { useState } from "react";

/* ══════════════════════════════════════════════════
   COMPLETE SCHEDULE — every slot from all screenshots
   Columns: [Mon, Tue, Wed, Thu, Fri, Sat, Sun]
══════════════════════════════════════════════════ */
const SCHEDULE = [
  {
    time: "8:00 am",
    slots: [
      { dept: "primary",    label: "Primary Health Care", doctor: "W.Geourge"  },
      { dept: "cardiology", label: "Cardiology",           doctor: "M.Anderson" },
      { dept: "primary",    label: "Primary Health Care", doctor: "William.G"  },
      { dept: "cardiology", label: "Cardiology",           doctor: "Mathew.K"   },
      { dept: "primary",    label: "Primary Health Care", doctor: "Gill.B"     },
      null,
      { dept: "primary",    label: "Primary Health Care", doctor: "Cooper.L"   },
    ],
  },
  {
    time: "9:00 am",
    slots: [
      null,
      { dept: "cardiology", label: "Cardiology",           doctor: "Mathew.K"  },
      null,
      null,
      { dept: "primary",    label: "Primary Health Care", doctor: "W.Geourge"  },
      { dept: "cardiology", label: "Cardiology",           doctor: "Martin.C"  },
      { dept: "primary",    label: "Primary Health Care", doctor: "W.Geourge"  },
    ],
  },
  {
    time: "10:00 am",
    slots: [
      { dept: "primary",    label: "Primary Health Care", doctor: "William.G"  },
      null,
      { dept: "primary",    label: "Primary Health Care", doctor: "W.Geourge"  },
      { dept: "cardiology", label: "Cardiology",           doctor: "Martin.C"  },
      null,
      null,
      null,
    ],
  },
  {
    time: "11:00 am",
    slots: [
      null,
      { dept: "cardiology", label: "Cardiology",           doctor: "Martin.C"   },
      { dept: "primary",    label: "Primary Health Care", doctor: "Gill.B"      },
      { dept: "cardiology", label: "Cardiology",           doctor: "M.Anderson" },
      { dept: "primary",    label: "Primary Health Care", doctor: "William.G"   },
      { dept: "cardiology", label: "Cardiology",           doctor: "M.Anderson" },
      null,
    ],
  },
  {
    time: "12:00 pm",
    slots: [
      { dept: "primary",    label: "Primary Health Care", doctor: "Gill.B"      },
      { dept: "cardiology", label: "Cardiology",           doctor: "M.Anderson" },
      null,
      { dept: "cardiology", label: "Cardiology",           doctor: "Mathew.K"   },
      { dept: "primary",    label: "Primary Health Care", doctor: "Cooper.L"    },
      null,
      null,
    ],
  },
  {
    time: "1:00 pm",
    slots: [
      null,
      { dept: "cardiology", label: "Cardiology",           doctor: "Mathew.K"  },
      { dept: "primary",    label: "Primary Health Care", doctor: "Cooper.L"   },
      null,
      { dept: "primary",    label: "Primary Health Care", doctor: "Gill.B"     },
      null,
      { dept: "primary",    label: "Primary Health Care", doctor: "William.G"  },
    ],
  },
];

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

/*
  EXACT empty-cell background per column index (0=Mon…6=Sun):
  Odd columns (Tue=1, Thu=3, Sat=5) → teal  #3ab5a0
  Even columns (Mon=0, Wed=2, Fri=4, Sun=6) → navy #1e3259
  
  When a filter is active and the cell has NO slot of either dept:
  → show light grey #e0e0e0 (as seen clearly in screenshots 5&6)
  
  When a filter is active but the cell has a slot of the OTHER dept:
  → keep the column alternating color (navy/teal) — same as All view
    (screenshots 3&4 show the column bg color when filtered out)
*/
const COL_BG = [
  "#1e3259",  // Mon  - navy
  "#3ab5a0",  // Tue  - teal
  "#1e3259",  // Wed  - navy
  "#3ab5a0",  // Thu  - teal
  "#1e3259",  // Fri  - navy
  "#3ab5a0",  // Sat  - teal
  "#1e3259",  // Sun  - navy
];

/* ══════════════════════════════════════════════════
   EXACT CSS — every value measured from screenshots
══════════════════════════════════════════════════ */
const CSS = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .dp-page {
    overflow-x: hidden;
    font-family: 'Segoe UI', Roboto, Arial, sans-serif;
    background: #3ab5a0;
  }

  /* ── TEAL HERO BAND ──
     Big teal space above dropdown, ~90px tall
     Exact same color as page bg: #3ab5a0
  */
  .dp-hero {
    background: #3ab5a0;
    height: 90px;
  }

  /* ── DROPDOWN SECTION ──
     Teal bg, dropdown sits in top-left
     Padding: left 20px, bottom 20px
  */
  .dp-filter {
    background: #3ab5a0;
    padding: 0 0 22px 20px;
  }

  /* ── SELECT BOX ──
     Exact from screenshots:
     - White background
     - Black border 2px solid
     - Rounded corners ~5px
     - Width ~290px, height ~50px
     - Font: 16px, color #111, weight 400
     - Padding: 12px left, 45px right for arrow
     - Arrow: small black chevron right side
  */
  .dp-select {
    appearance: none;
    -webkit-appearance: none;
    background-color: #ffffff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1.5l5 5 5-5' stroke='%23111' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 16px center;
    border: 2px solid #111111;
    border-radius: 5px;
    padding: 13px 46px 13px 16px;
    font-size: 16px;
    font-weight: 400;
    color: #111111;
    cursor: pointer;
    width: 290px;
    height: 50px;
    letter-spacing: 0px;
  }
  .dp-select:focus {
    outline: none;
  }

  /* ── TABLE OUTER SECTION ──
     Teal background continues, padding around the white card
     Padding: 0 16px 0 16px (table goes edge to edge width)
  */
  .dp-table-section {
    background: #3ab5a0;
    padding: 0 16px 80px 16px;
  }

  /* ── WHITE CARD ──
     White background, very slight shadow
     No border-radius visible in screenshots
  */
  .dp-card {
    background: #ffffff;
    border-radius: 0;
    overflow-x: auto;
    box-shadow: 0 1px 8px rgba(0,0,0,0.10);
  }

  /* ── TABLE ──
     Full width, fixed layout
  */
  .dp-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    min-width: 760px;
  }

  /* ── HEADER ROW ──
     White bg, text color #1a1a1a, font 15px bold
     Row height ~56px
     Bottom border: 1px solid #cccccc
     Right border between each column: 1px solid #cccccc
  */
  .dp-table thead tr {
    height: 56px;
  }
  .dp-table thead th {
    background: #ffffff;
    color: #1a1a1a;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    vertical-align: middle;
    padding: 0 8px;
    border-bottom: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
  }
  .dp-table thead th:last-child {
    border-right: none;
  }

  /* ── CALENDAR ICON HEADER CELL ──
     Background: same teal as page #3ab5a0
     Width: ~90px
     No bottom border (teal on teal)
  */
  .dp-table thead th.th-icon {
    background: #3ab5a0;
    width: 90px;
    border-bottom: 1px solid #3ab5a0;
    border-right: 1px solid rgba(255,255,255,0.25);
  }

  /* ── TIME LABEL COLUMN ──
     Exact color from screenshot: very pale mint #e8f5f2
     Text: dark navy #1a3550, bold, 14px
     Width: 90px
     Right border: 1px solid #c0ddd7
     Bottom border between rows: 1px solid #cccccc
     Text centered
  */
  .dp-time {
    background: #e8f5f2;
    color: #1a3550;
    font-weight: 700;
    font-size: 14px;
    text-align: center;
    vertical-align: middle;
    padding: 10px 5px;
    border-right: 1px solid #c0ddd7;
    border-bottom: 1px solid #cccccc;
    white-space: nowrap;
    width: 90px;
  }

  /* ── DATA CELLS ──
     Border: 1px solid #cccccc between cells
  */
  .dp-table tbody td {
    padding: 0;
    border-right: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
    vertical-align: top;
  }
  .dp-table tbody td:last-child {
    border-right: none;
  }
  .dp-table tbody tr:last-child td {
    border-bottom: none;
  }

  /* ── CELL INNER ──
     Min height: 110px (each row is ~110px tall)
     Padding: 18px 16px
     Flexbox column, content centered vertically
  */
  .dp-cell {
    min-height: 110px;
    padding: 18px 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }

  /* ── PRIMARY HEALTH CARE ──
     Dark navy: #1e3259
  */
  .dp-primary {
    background: #1e3259;
  }

  /* ── CARDIOLOGY ──
     Teal: #3ab5a0
  */
  .dp-cardiology {
    background: #3ab5a0;
  }

  /* ── DEPT LABEL TEXT ──
     Color: white #ffffff
     Font: 14px, weight 600 (semi-bold)
     Margin-bottom: 8px
     Line-height: 1.4
  */
  .dp-dept {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 8px;
    line-height: 1.4;
  }

  /* ── DIVIDER LINE ──
     Width: 26px
     Height: 2px
     Color: rgba(255,255,255,0.45) — semi-transparent white
     Margin-bottom: 8px
  */
  .dp-line {
    width: 26px;
    height: 2px;
    background: rgba(255, 255, 255, 0.45);
    margin-bottom: 8px;
    flex-shrink: 0;
  }

  /* ── DOCTOR NAME TEXT ──
     Color: white #ffffff
     Font: 14px, weight 400 (normal)
     Line-height: 1.3
  */
  .dp-doc {
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 1.3;
  }

  /* ══ RESPONSIVE ══ */
  @media (max-width: 1024px) {
    .dp-select { width: 240px; }
    .dp-table thead th { font-size: 13px; }
    .dp-time { font-size: 12px; width: 76px; }
    .dp-dept, .dp-doc { font-size: 12px; }
    .dp-cell { min-height: 90px; padding: 14px 10px; }
  }
  @media (max-width: 768px) {
    .dp-hero { height: 60px; }
    .dp-filter { padding: 0 0 16px 12px; }
    .dp-select { width: 210px; height: 44px; font-size: 14px; padding: 10px 38px 10px 12px; }
    .dp-table-section { padding: 0 8px 50px; }
    .dp-table thead th { font-size: 11px; padding: 0 3px; }
    .dp-table thead th.th-icon { width: 68px; }
    .dp-time { font-size: 10px; width: 60px; padding: 8px 3px; }
    .dp-dept, .dp-doc { font-size: 11px; }
    .dp-line { width: 18px; margin-bottom: 5px; }
    .dp-cell { min-height: 80px; padding: 10px 7px; }
  }
  @media (max-width: 480px) {
    .dp-select { width: 180px; font-size: 13px; }
    .dp-table thead th { font-size: 9px; }
    .dp-time { font-size: 9px; width: 52px; }
    .dp-dept, .dp-doc { font-size: 9px; }
    .dp-cell { min-height: 65px; padding: 7px 5px; }
  }
`;

/* ── CALENDAR SVG ICON ──
   White grid/calendar icon exactly as in screenshot
*/
function CalendarIcon() {
  return (
    <svg
      viewBox="0 0 30 30"
      width="34"
      height="34"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* outer box */}
      <rect x="2" y="4" width="26" height="24" rx="2.5"
            fill="none" stroke="#ffffff" strokeWidth="2" />
      {/* horizontal separator */}
      <line x1="2" y1="11" x2="28" y2="11"
            stroke="#ffffff" strokeWidth="2" />
      {/* left peg */}
      <line x1="9"  y1="2" x2="9"  y2="8"
            stroke="#ffffff" strokeWidth="2.2" strokeLinecap="round" />
      {/* right peg */}
      <line x1="21" y1="2" x2="21" y2="8"
            stroke="#ffffff" strokeWidth="2.2" strokeLinecap="round" />
      {/* dot grid — row 1 */}
      <rect x="7.5"  y="14.5" width="3" height="3" rx="0.5" fill="#ffffff" />
      <rect x="13.5" y="14.5" width="3" height="3" rx="0.5" fill="#ffffff" />
      <rect x="19.5" y="14.5" width="3" height="3" rx="0.5" fill="#ffffff" />
      {/* dot grid — row 2 */}
      <rect x="7.5"  y="20"   width="3" height="3" rx="0.5" fill="#ffffff" />
      <rect x="13.5" y="20"   width="3" height="3" rx="0.5" fill="#ffffff" />
      <rect x="19.5" y="20"   width="3" height="3" rx="0.5" fill="#ffffff" />
    </svg>
  );
}

/* ══════════════════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════════════════ */
function Department() {
  const [filter, setFilter] = useState("all");

  const handleChange = (e) => {
    const val = e.target.value;
    setFilter(val);
    const hashMap = {
      all:        "#not-set:all",
      primary:    "#not-set:primary-health-care",
      cardiology: "#not-set:cardiology",
    };
    window.location.hash = hashMap[val] || "";
  };

  /*
    Render one table cell based on:
    - slot: the data object or null
    - colIdx: column index 0-6
    - filter: current filter
    
    RULES observed from screenshots:
    1. Slot exists and matches filter → show colored card (navy or teal)
    2. Slot exists but doesn't match filter → show column bg color (navy/teal)
       This is visible in img3: Primary filter, Tue col has teal bg (cardiology slot hidden)
    3. No slot at all (null) → 
       - filter=all → show column bg color (navy/teal alternating)
       - filter=primary/cardiology → show light grey #e0e0e0
       This is visible in img5 (Cardiology): Mon, Wed, Fri, Sun show grey (no cardiology slot)
       And img3 (Primary): Tue, Thu, Sat show grey (no primary slot)
  */
  const renderCell = (slot, colIdx) => {
    const colBg = COL_BG[colIdx];
    const matches = slot && (filter === "all" || filter === slot.dept);

    // CASE 1: show the card
    if (matches) {
      const bg = slot.dept === "primary" ? "#1e3259" : "#3ab5a0";
      return (
        <div className="dp-cell" style={{ background: bg }}>
          <div className="dp-dept">{slot.label}</div>
          <div className="dp-line" />
          <div className="dp-doc">{slot.doctor}</div>
        </div>
      );
    }

    // CASE 2: slot exists but filtered out → column alternating color
    if (slot && filter !== "all") {
      return (
        <div className="dp-cell" style={{ background: colBg }} />
      );
    }

    // CASE 3a: null slot, filter=all → column alternating color
    if (!slot && filter === "all") {
      return (
        <div className="dp-cell" style={{ background: colBg }} />
      );
    }

    // CASE 3b: null slot, filter active → grey
    return (
      <div className="dp-cell" style={{ background: "#e0e0e0" }} />
    );
  };

  return (
    <div className="dp-page">
      <style>{CSS}</style>

      {/* Shared components */}

      {/* Teal hero band above dropdown */}
      <div className="dp-hero" />

      {/* Dropdown */}
      <div className="dp-filter">
        <select className="dp-select" value={filter} onChange={handleChange}>
          <option value="all">All Departments</option>
          <option value="primary">Primary Health Care</option>
          <option value="cardiology">Cardiology</option>
        </select>
      </div>

      {/* Schedule Table */}
      <div className="dp-table-section">
        <div className="dp-card">
          <table className="dp-table">

            {/* HEADER */}
            <thead>
              <tr>
                <th className="th-icon">
                  <CalendarIcon />
                </th>
                {DAYS.map((day) => (
                  <th key={day}>{day}</th>
                ))}
              </tr>
            </thead>

            {/* BODY */}
            <tbody>
              {SCHEDULE.map((row) => (
                <tr key={row.time}>
                  {/* Time label */}
                  <td className="dp-time">{row.time}</td>
                  {/* 7 day columns */}
                  {row.slots.map((slot, ci) => (
                    <td key={ci}>
                      {renderCell(slot, ci)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      </div>

      {/* Footer */}
    </div>
  );
}

export default Department;
